@if (isError()) {
  <sd-system-message type="error">
    <span>Произошла непредвиденная ошибка. Попробуйте повторить попытку позже или обратитесь в службу поддержки</span>
  </sd-system-message>
}

@if (isConsignmentError()) {
  <sd-system-message type="error">
    <span>
      Заказ не может быть оформлен. Произошла непредвиденная ошибка. Попробуйте обновить страницу или обратитесь в
      службу поддержки
    </span>
  </sd-system-message>
}

<button
  sdButton
  theme="primary"
  [fullWidth]="fullWidth()"
  (click)="onSubmit()"
  [disabled]="isLoading() || isConsignmentError()"
>
  оформить заказ
</button>
